import { render } from "./replies.vue?vue&type=template&id=43000c27&scoped=true&ts=true"
import script from "./replies.vue?vue&type=script&lang=ts"
export * from "./replies.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=43000c27&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43000c27"]])

export default __exports__